var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: ["message-block", _vm.msg.received ? "received" : "sent"] },
    [
      _vm.msg.received
        ? _c("img", {
            staticClass: "message-photo",
            attrs: { src: _vm.userPhoto, alt: "" }
          })
        : _c("img", {
            staticClass: "message-photo",
            attrs: { src: _vm.$store.state.session.user.photo, alt: "" }
          }),
      _vm._v(" "),
      !_vm.msg.file
        ? _c("p", {
            staticClass: "chat-message",
            domProps: { innerHTML: _vm._s(_vm.msg.text) }
          })
        : _vm.msg.file.contentType.includes("audio")
        ? _c("audio-player", {
            staticClass: "audio-message",
            attrs: {
              secondaryStyle: _vm.msg.received,
              src: _vm.msg.file.fileUrl
            }
          })
        : _vm.msg.file.contentType.includes("image")
        ? _c("img", {
            staticClass: "chat-message image-message",
            attrs: { src: _vm.msg.file.fileUrl, alt: "" },
            on: {
              click: function($event) {
                return _vm.showImageFullSize(_vm.msg.file.fileUrl)
              }
            }
          })
        : _c("p", { staticClass: "chat-message document" }, [
            _c(
              "a",
              {
                attrs: {
                  href: _vm.msg.file.fileUrl,
                  target: "_blank",
                  download: _vm.msg.file.name
                }
              },
              [
                _c(
                  "base-button",
                  {
                    class: [_vm.msg.received ? "received" : "sent"],
                    attrs: { white: _vm.msg.received }
                  },
                  [
                    _c(
                      "span",
                      [
                        _c("b-icon-file-earmark-text"),
                        _vm._v("  " + _vm._s(_vm.msg.file.name))
                      ],
                      1
                    )
                  ]
                )
              ],
              1
            )
          ]),
      _vm._v(" "),
      _c("div", [
        _vm.msg.received || _vm.$store.state.chat.selectedChat.user.terminated
          ? _c("span", { staticClass: "message-date" }, [
              _vm._v(_vm._s(_vm.appointmentDateFormat(_vm.msg.date, true))),
              _vm.msg.edited
                ? _c("span", [_vm._v(" | " + _vm._s(_vm.$t("edited")))])
                : _vm._e()
            ])
          : _c("div", [
              _c(
                "span",
                { staticClass: "message-date" },
                [
                  _c("b-icon-three-dots", {
                    staticStyle: { cursor: "pointer" },
                    on: {
                      click: function($event) {
                        return _vm.toggleShowMsgOptions(_vm.msg.chatMessageId)
                      }
                    }
                  }),
                  _vm.msg.edited
                    ? _c("span", [_vm._v(" | " + _vm._s(_vm.$t("edited")))])
                    : _vm._e(),
                  _vm._v(" | "),
                  _vm.msg.read ? _c("b-icon-eye") : _vm._e(),
                  _vm._v(
                    " " +
                      _vm._s(_vm.appointmentDateFormat(_vm.msg.date, true)) +
                      "\n        "
                  ),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value:
                            _vm.$store.state.chat.showMsgOptions ===
                            _vm.msg.chatMessageId,
                          expression:
                            "$store.state.chat.showMsgOptions === msg.chatMessageId"
                        }
                      ],
                      ref: "messageMenu",
                      staticClass: "message-edit-delete"
                    },
                    [
                      _c("div", { staticClass: "mb-1" }, [
                        !_vm.msg.file
                          ? _c(
                              "span",
                              {
                                staticClass: "message-edit-element mr-3",
                                on: {
                                  click: function($event) {
                                    return _vm.editMessage(
                                      _vm.msg.chatMessageId
                                    )
                                  }
                                }
                              },
                              [
                                _c("b-icon-pencil", {
                                  staticClass: "mt-1 mr-1"
                                }),
                                _vm._v(_vm._s(_vm.$t("edit")))
                              ],
                              1
                            )
                          : _vm._e()
                      ]),
                      _vm._v(" "),
                      _c("div", [
                        _c(
                          "span",
                          {
                            staticClass: "message-edit-element delete",
                            on: {
                              click: function($event) {
                                return _vm.$store.commit(
                                  "chat/toggleShowDialog",
                                  "delete"
                                )
                              }
                            }
                          },
                          [
                            _c("b-icon-trash", { staticClass: "mt-1 mr-1" }),
                            _vm._v(_vm._s(_vm.$t("chats.delete")))
                          ],
                          1
                        )
                      ])
                    ]
                  )
                ],
                1
              )
            ])
      ]),
      _vm._v(" "),
      _vm.showFullImage
        ? _c(
            "div",
            {
              staticClass: "imgFullSize",
              on: {
                click: function($event) {
                  return _vm.showImageFullSize()
                }
              }
            },
            [_c("img", { attrs: { src: _vm.showFullImage, alt: "" } })]
          )
        : _vm._e(),
      _vm._v(" "),
      _c("base-dialog", {
        attrs: {
          content: _vm.$t("chats.delete-message"),
          okBtnText: _vm.$t("yes"),
          cancelBtnText: _vm.$t("no"),
          okFn: function() {
            _vm.$store.dispatch("chat/deleteMessage", _vm.msg.chatMessageId)
          },
          cancelFn: function() {
            _vm.$store.commit("chat/toggleShowDialog", "delete")
          }
        },
        model: {
          value: _vm.showDeleteDialog,
          callback: function($$v) {
            _vm.showDeleteDialog = $$v
          },
          expression: "showDeleteDialog"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3c4bfcbc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3c4bfcbc","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/chat-interconsultations/ChatMessage.vue
// module id = 4000
// module chunks = 14